/**
 *
 * @module deviceManagerConfiguration
 *
 */

import ServiceConfiguration from './serviceConfiguration';

/**
 *
 * @class DeviceManagerConfiguration
 *
 */
export default class DeviceManagerConfiguration extends ServiceConfiguration {}



// WEBPACK FOOTER //
// ./src/services/configuration/deviceManagerConfiguration.js